import { h } from 'preact';

import SelectFilter from './components/SelectFilter';
import FiltersButton from './components/FiltersButton';

export default function ViewFilterModal({
	filters,
	onFilterChangeHandler,
	onFiltersResetHandler,
	applyFiltersHandler
}) {
	function renderFilter(data){
		switch (data.type){
		case 'select':
			return <SelectFilter {...data} onChangeHandler={onFilterChangeHandler} />;
		}
	}

	return (
		<div class="newsitems-filter-filters-wrapper">
			{filters.map(filter => (
				renderFilter(filter)
			))}
			<FiltersButton type="submit" onClickHandler={applyFiltersHandler}>Toon resultaat</FiltersButton>
			<FiltersButton type="reset" onClickHandler={onFiltersResetHandler}>Reset filters</FiltersButton>
		</div>
	);

}
